import api from 'api';

export default function resizeWorker(workerId: string, cores: number) {
  return api.patch(`workers/${workerId}`, { json: { cores } });
}
